var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.109,
    height: 59.109,
    viewBox: "0 0 59.109 59.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9,13.826a.985.985,0,0,0-.874,1.184L5.343,30.782A41.374,41.374,0,0,0,31.2,61.044a.99.99,0,0,0,.7,0A41.374,41.374,0,0,0,57.767,30.782L61.088,15.01a.985.985,0,0,0-.874-1.184l-1.425-.13A39.772,39.772,0,0,1,41.738,8.052L32.069,2.144a.988.988,0,0,0-1.028,0L21.374,8.052A39.785,39.785,0,0,1,4.321,13.7ZM22.4,9.734,31.554,4.14l9.154,5.595a41.769,41.769,0,0,0,17.9,5.925l.322.029L55.839,30.376A39.407,39.407,0,0,1,31.554,59.067,39.407,39.407,0,0,1,7.27,30.376L4.177,15.688l.321-.029A41.8,41.8,0,0,0,22.4,9.734Z",
    transform: "translate(-2 -1.999)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.955,32.733h5.911v2.955H24.9a.985.985,0,0,0-.985.985V48.495a.985.985,0,0,0,.985.985H38.688a.985.985,0,0,0,.985-.985V36.673a.985.985,0,0,0-.985-.985h-1.97V32.733h5.911a2.959,2.959,0,0,0,2.955-2.955V17.955A2.959,2.959,0,0,0,42.629,15H20.955A2.959,2.959,0,0,0,18,17.955V29.777A2.959,2.959,0,0,0,20.955,32.733ZM37.7,47.51H25.881V37.658H37.7ZM34.747,35.688H28.837V32.733h5.911Zm7.881-4.926H29.018a2.951,2.951,0,0,1,2.774-1.97v-1.97a4.935,4.935,0,0,0-4.826,3.941h-6.01a.986.986,0,0,1-.985-.985V24.851H43.614v4.926A.986.986,0,0,1,42.629,30.762ZM19.97,22.881v-1.97H43.614v1.97Zm.985-5.911H42.629a.986.986,0,0,1,.985.985v.985H19.97v-.985A.986.986,0,0,1,20.955,16.97Z",
    transform: "translate(-2.238 -2.193)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.985,45.911h1.97V41.97h.985V40H30v1.97h.985Z",
    transform: "translate(-2.416 -2.564)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,39h1.97v1.97H42Z",
    transform: "translate(-2.594 -2.549)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,39h1.97v1.97H46Z",
    transform: "translate(-2.654 -2.549)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,35h1.97v1.97H46Z",
    transform: "translate(-2.654 -2.49)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,43h1.97v1.97H46Z",
    transform: "translate(-2.654 -2.609)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,39h1.97v1.97H20Z",
    transform: "translate(-2.267 -2.549)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,39h1.97v1.97H16Z",
    transform: "translate(-2.208 -2.549)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,35h1.97v1.97H16Z",
    transform: "translate(-2.208 -2.49)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,43h1.97v1.97H16Z",
    transform: "translate(-2.208 -2.609)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.14b058cc.svg";
export { ForwardRef as ReactComponent };